import React from 'react'

const ExploreQuickStayCoLiving = () => {
  return (
    <div>
     ExploreQuickStayCoLiving 
    </div>
  )
}

export default ExploreQuickStayCoLiving
